module.exports = __webpack_public_path__ + "img/10_43.a28985ae.png";